import * as React from "react"

import {cn} from "@/lib/utils"
import {ReactElement} from "react";

export interface InputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    icon?: ReactElement
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({icon, className, type, ...props}, ref) => {
        return (
            <div className='relative'>
                <input
                    type={type}
                    className={cn(
                        "h-12 w-full rounded-md border border-input bg-neutral-50 px-3 py-4 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
                        className
                    )}
                    ref={ref}
                    {...props}
                />
                {
                    icon && (<div
                        className='absolute right-3 top-[50%] touch-none select-none translate-y-[-50%]'>{icon}</div>)
                }

            </div>
        )
    }
)
Input.displayName = "Input"

export {Input}
